module.exports = __webpack_public_path__ + "e71a0d82492882b5a7b5dd5c21f4538d.pdf";